import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/appStore.svg';

export const IconAppStore = createIconComponent(Icon);
